import Vue from 'vue';
import marketplaceProductTransformer from '../../transformers/marketplaceProduct';

const success = ({ data }, resolve) => {
  const marketplaceProducts = marketplaceProductTransformer.fetchCollection(data.data);
  resolve(marketplaceProducts);
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/products/marketplace')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/all.js